/**
 * Loader for the Google Consent Mode V2
 */
export default class gtm {
	constructor(app) {
		this.app = app;
		// Get the correct gtagkey
		const metagtagkey = document.querySelector('meta[name="google-tag-manager"]');
		const gtagkey = metagtagkey ? metagtagkey.getAttribute('content') : null;

		//console.error('GTM key: %o', gtagkey);

		document.addEventListener('cookie-manager-ready', (e) => {
			console.debug('submit consent: %o', e.detail.allowedCookies)
		})

		window.dataLayer = window.dataLayer || [];
		gtag('config', gtagkey);

		gtag('consent', 'default', {
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'ad_storage': 'denied',
			'analytics_storage': 'denied',
			'functionality_storage': 'denied',
			'personalization_storage': 'denied',
			'security_storage': 'granted',
		});


		document.addEventListener('cookie-allowed-marketing-googleads', (e) => {
			console.log('gtm cookie accepted! load script')
			window.dataLayer = window.dataLayer || [];
			localStorage.setItem("consentGranted", "true");

			//gtag('js', new Date());

			gtag('consent', 'update', {
				'ad_user_data': 'granted',
				'ad_personalization': 'granted',
				'ad_storage': 'granted',
				'analytics_storage': 'denied',
				'functionality_storage': 'denied',
				'personalization_storage': 'denied',
				'security_storage': 'granted',
			});

		})

		function gtag() {
			dataLayer.push(arguments);
		}
	}
}
